import { useState, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { userSlice } from '../../store/reducers/userReducer';
import { uiSlice } from '../../store/reducers/uiReducer';
import ToolTip, { IToolTipObject } from '../ui/ToolTip';

import headSlots from '../../assets/img/item_slots/Head.png'
import headSlotsWebp from '../../assets/img/item_slots/Head.webp'
import chestSlots from '../../assets/img/item_slots/Chest.png'
import chestSlotsWebp from '../../assets/img/item_slots/Chest.webp'
import beltSlots from '../../assets/img/item_slots/Belt.png'
import beltSlotsWebp from '../../assets/img/item_slots/Belt.webp'
import legsSlots from '../../assets/img/item_slots/Legs.png'
import legsSlotsWebp from '../../assets/img/item_slots/Legs.webp'
import feetSlots from '../../assets/img/item_slots/Feet.png'
import feetSlotsWebp from '../../assets/img/item_slots/Feet.webp'
import ImgWithFallback from '../ui/ImgWithFallback';

const CharacterWindowArmor = () => {
    // redux const
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const characterInventory = useAppSelector(state => state.userReducer.character.getInventory())
    const dispatch = useAppDispatch()
    const { setInventoryLength } = userSlice.actions
    const { setToolTipContent } = uiSlice.actions
    const toolTipContent = useAppSelector(state => state.uiReducer.toolTipContent)
    // state
    const [isToolTipView, setIsToolTipView] = useState(false)

    function callToolTip(tipContent: string) {
        setIsToolTipView(true)
        dispatch(setToolTipContent(tipContent))
    }

    const handleRemoveItem = useCallback(() => {
        if (mainCharacter.getEquipment().armor.getArmorType()) {
            mainCharacter.getEquipment().armor.remove(mainCharacter, characterInventory)
            dispatch(setInventoryLength())
        }
    }, [])

    const armorTollTip: IToolTipObject = {
        type: mainCharacter.getEquipment().armor.getArmorType(),
        name: mainCharacter.getEquipment().armor.getName(),
        armorValue: mainCharacter.getEquipment().armor.getArmorValue(),
        cost: mainCharacter.getEquipment().armor.getCost()
    }

    return (
        <ul className="equipment__slots">
            <li className="equipment__slot">
                <ImgWithFallback src={headSlotsWebp} fallbackSrc={headSlots} />
            </li>
            <li className="equipment__slot" onClick={handleRemoveItem} onMouseEnter={() => callToolTip(toolTipContent)} onMouseLeave={() => setIsToolTipView(false)}>
                {
                    mainCharacter.getEquipment().armor.getArmorType() ?
                        <>
                            <ImgWithFallback
                                src={mainCharacter.getEquipment().armor.getImg().webp}
                                fallbackSrc={mainCharacter.getEquipment().armor.getImg().img}
                                classNames={'_isEquipped'} />
                            {isToolTipView ?
                                <ToolTip
                                    text=''
                                    toolTipObjectContent={armorTollTip}
                                    position='top-inventory-items' />
                                :
                                null
                            }
                        </>
                        :
                        <ImgWithFallback src={chestSlotsWebp} fallbackSrc={chestSlots} />
                }
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={beltSlotsWebp} fallbackSrc={beltSlots} />
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={legsSlotsWebp} fallbackSrc={legsSlots} />
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={feetSlotsWebp} fallbackSrc={feetSlots} />
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={feetSlotsWebp} fallbackSrc={feetSlots} />
            </li>
        </ul>
    );
};

export default CharacterWindowArmor;